var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "x-logo",
    d: "M11.875 8.5L19.375 0H17.625L11.125 7.375L5.9375 0H0L7.8125 11.125L0 20H1.75L8.5625 12.25L14.0625 20H20L11.875 8.5ZM9.5 11.1875L8.6875 10.0625L2.375 1.3125H5.0625L10.125 8.4375L10.9375 9.5625L17.5625 18.75H14.875L9.5 11.1875Z",
    fill: "#1930FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.86bc716341db3b960ab3a4e66b944412.svg";
export { ForwardRef as ReactComponent };